export enum LoginErrorReason {
    EMAIL_ERROR = 'email_error',
    PASSWORD_ERROR = 'password_error',
    OESUSPENDED = 'oesuspended',
    STUDENTPAUSED = 'studentpaused',
    OECANCELED = 'oecancelled',
    CUSTOMERCANCELLED = 'customercancelled',
    FAILEDSALE = 'failedsale',
    SERVICECOMPLETE = 'servicecomplete',
    UNKNOWN = 'unknown',
}

export interface LoginDto {
    success: boolean;
    reason?: LoginErrorReason;
    attempt?: number;
    countryCode?: string;
    url?: string;
    accountSharing?: boolean;
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/LoginDto.ts